import { render } from "./SubmitSelector.vue?vue&type=template&id=15471c01&scoped=true&ts=true"
import script from "./SubmitSelector.vue?vue&type=script&lang=ts"
export * from "./SubmitSelector.vue?vue&type=script&lang=ts"

import "./SubmitSelector.vue?vue&type=style&index=0&id=15471c01&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15471c01"]])

export default __exports__